import React from 'react';
import './whatsAppButton.scss';
import { useCookiesContext } from '../../hooks/useCookiesContext';
import { fireAnalytics } from '../../service/HomePageAnalyticsService';
import { ANALYTICS_CONSTANTS } from '../../../../common/constants/AnalyticsConstants';

const WhatsAppButton: React.FC = () => {
  const { showCookiesContainer } = useCookiesContext();

  const handleChatLink = () => {
    // Fire click analytics
    fireAnalytics({
      section: ANALYTICS_CONSTANTS.bottomWidget,
      eventAction: ANALYTICS_CONSTANTS.click,
      eventLabel: ANALYTICS_CONSTANTS.whatsAppButton,
      customLabel: ANALYTICS_CONSTANTS.button,
      customValue:'',
      eventValue: '', 
      isInteractive: '1',
      horizontalPosition: '1',
      verticalPosition: '0',
    });

    const whatsappBusinessNumber = '919100191001';
    const message = 'Hi!';
    const chatUrl = `https://wa.me/${whatsappBusinessNumber}?text=${encodeURIComponent(message)}`;
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile) {
      window.location.href = chatUrl;
    } else {
      window.open(chatUrl, '_blank');
    }
  };

  return (
    <div
      className={`share-whatsapp ${
        showCookiesContainer ? 'cookies-visible-class' : ''
      }`}
    >
      <button
        className="whatsapp-share-btn"
        onClick={handleChatLink}
        aria-label="Chat with us on WhatsApp"
      >
        <img
          className="whatsapp_icon"
          src="https://assets.airtel.in/static-assets/cms/iq/partner-detail-page-share-icon-2062023.svg"
          alt="WhatsApp icon for starting a chat"
        />
      </button>
    </div>
  );
};

export default WhatsAppButton;
